"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _EthereumL1BitcoinDepositor_extraDataEncoder;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumCrossChainExtraDataEncoder = exports.EthereumL1BitcoinDepositor = void 0;
const adapter_1 = require("./adapter");
const contracts_1 = require("../contracts");
const index_1 = require("./index");
const utils_1 = require("../utils");
const BaseL1BitcoinDepositor_json_1 = __importDefault(require("./artifacts/mainnet/BaseL1BitcoinDepositor.json"));
const ArbitrumOneL1BitcoinDepositor_json_1 = __importDefault(require("./artifacts/mainnet/ArbitrumOneL1BitcoinDepositor.json"));
const BaseL1BitcoinDepositor_json_2 = __importDefault(require("./artifacts/sepolia/BaseL1BitcoinDepositor.json"));
const ArbitrumL1BitcoinDepositor_json_1 = __importDefault(require("./artifacts/sepolia/ArbitrumL1BitcoinDepositor.json"));
const artifactLoader = {
    getMainnet: (l2ChainName) => {
        switch (l2ChainName) {
            case "Base":
                return BaseL1BitcoinDepositor_json_1.default;
            case "Arbitrum":
                return ArbitrumOneL1BitcoinDepositor_json_1.default;
            default:
                throw new Error("Unsupported L2 chain");
        }
    },
    getSepolia: (l2ChainName) => {
        switch (l2ChainName) {
            case "Base":
                return BaseL1BitcoinDepositor_json_2.default;
            case "Arbitrum":
                return ArbitrumL1BitcoinDepositor_json_1.default;
            default:
                throw new Error("Unsupported L2 chain");
        }
    },
};
/**
 * Implementation of the Ethereum L1BitcoinDepositor handle. It can be
 * constructed for each supported L2 chain.
 * @see {L1BitcoinDepositor} for reference.
 */
class EthereumL1BitcoinDepositor extends adapter_1.EthersContractHandle {
    constructor(config, chainId, l2ChainName) {
        let deployment;
        switch (chainId) {
            case contracts_1.Chains.Ethereum.Sepolia:
                deployment = artifactLoader.getSepolia(l2ChainName);
                break;
            case contracts_1.Chains.Ethereum.Mainnet:
                deployment = artifactLoader.getMainnet(l2ChainName);
                break;
            default:
                throw new Error("Unsupported deployment type");
        }
        super(config, deployment);
        _EthereumL1BitcoinDepositor_extraDataEncoder.set(this, void 0);
        __classPrivateFieldSet(this, _EthereumL1BitcoinDepositor_extraDataEncoder, new EthereumCrossChainExtraDataEncoder(), "f");
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L1BitcoinDepositor#getDepositState}
     */
    getDepositState(depositId) {
        return this._instance.deposits(depositId);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L1BitcoinDepositor#getChainIdentifier}
     */
    getChainIdentifier() {
        return index_1.EthereumAddress.from(this._instance.address);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L1BitcoinDepositor#extraDataEncoder}
     */
    extraDataEncoder() {
        return __classPrivateFieldGet(this, _EthereumL1BitcoinDepositor_extraDataEncoder, "f");
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {L1BitcoinDepositor#initializeDeposit}
     */
    async initializeDeposit(depositTx, depositOutputIndex, deposit, vault) {
        const { fundingTx, reveal } = (0, index_1.packRevealDepositParameters)(depositTx, depositOutputIndex, deposit, vault);
        if (!deposit.extraData) {
            throw new Error("Extra data is required");
        }
        const l2DepositOwner = this.extraDataEncoder().decodeDepositOwner(deposit.extraData);
        const tx = await this._instance.initializeDeposit(fundingTx, reveal, `0x${l2DepositOwner.identifierHex}`);
        return utils_1.Hex.from(tx.hash);
    }
}
exports.EthereumL1BitcoinDepositor = EthereumL1BitcoinDepositor;
_EthereumL1BitcoinDepositor_extraDataEncoder = new WeakMap();
/**
 * Implementation of the Ethereum CrossChainExtraDataEncoder.
 * @see {CrossChainExtraDataEncoder} for reference.
 */
class EthereumCrossChainExtraDataEncoder {
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {CrossChainExtraDataEncoder#encodeDepositOwner}
     */
    encodeDepositOwner(depositOwner) {
        // Make sure we are dealing with an Ethereum address. If not, this
        // call will throw.
        const address = index_1.EthereumAddress.from(depositOwner.identifierHex);
        // Extra data must be 32-byte so prefix the 20-byte address with
        // 12 zero bytes.
        return utils_1.Hex.from(`000000000000000000000000${address.identifierHex}`);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {CrossChainExtraDataEncoder#decodeDepositOwner}
     */
    decodeDepositOwner(extraData) {
        // Cut the first 12 zero bytes of the extra data and convert the rest to
        // an Ethereum address.
        return index_1.EthereumAddress.from(utils_1.Hex.from(extraData.toBuffer().subarray(12)).toString());
    }
}
exports.EthereumCrossChainExtraDataEncoder = EthereumCrossChainExtraDataEncoder;
//# sourceMappingURL=l1-bitcoin-depositor.js.map